import {
  BaleBotConfig,
  BaleBotSubscriber,
  Paginated,
} from "@/types";
import { del, get, patch, post, put } from "./client";

export async function getBaleBotConfig(): Promise<BaleBotConfig> {
  return get<BaleBotConfig>("/bale-bot/config");
}

export async function updateBaleBotConfig(
  config: Partial<BaleBotConfig>,
): Promise<BaleBotConfig> {
  return put<BaleBotConfig>("/bale-bot/config", config);
}

export interface ListBaleBotSubscribersParams {
  limit?: number;
  offset?: number;
}

export async function listBaleBotSubscribers(
  params: ListBaleBotSubscribersParams = {},
): Promise<Paginated<BaleBotSubscriber>> {
  const query = new URLSearchParams();
  if (params.limit !== undefined) {
    query.set("limit", String(params.limit));
  }
  if (params.offset !== undefined) {
    query.set("offset", String(params.offset));
  }
  const qs = query.toString();
  return get<Paginated<BaleBotSubscriber>>(
    `/bale-bot/subscribers${qs ? `?${qs}` : ""}`,
  );
}

export async function updateBaleBotSubscriber(
  id: string,
  data: Partial<BaleBotSubscriber>,
): Promise<BaleBotSubscriber> {
  return patch<BaleBotSubscriber>(`/bale-bot/subscribers/${id}`, data);
}

export async function deleteBaleBotSubscriber(id: string): Promise<void> {
  return del(`/bale-bot/subscribers/${id}`);
}

export async function sendBaleBotTestMessage(
  chat_id: string | null,
  text: string | null,
): Promise<{ ok: boolean; detail: unknown }> {
  return post<{ ok: boolean; detail: unknown }>("/bale-bot/test-message", {
    chat_id,
    text,
  });
}
